import { PickupItem, ShipPrices } from "./OrderItemsSection";

interface Props {
    item: PickupItem;
    index?: number;
    idx: number;
    shipPrices: ShipPrices;
    isChild: boolean;
    ffid?: string;
}

const OrderDetailsPriceRow = ({ item, index, idx, shipPrices, isChild, ffid }: Props) => {
    const isMediaChild = item.isMediaClipProduct && isChild;

    const oldPrice = isMediaChild ? shipPrices?.price : item.price;
    const currentPrice = isMediaChild
        ? shipPrices?.currentPrice
        : item.currentPrice;
    const total = isMediaChild ? shipPrices?.total : item.total;
    const rowFfid = `${ffid ? '-' + ffid : ''}${index}-${idx}`;

    return (
        <div className="flex gap-4 sm:gap-8 lg:gap-12">
            {/* Price Section */}
            <div
                className="flex min-w-[120px] max-w-[220px] flex-col-reverse items-end justify-end gap-x-8 gap-y-4 whitespace-nowrap text-right sm:min-w-80 lg:flex-row"
                data-ffid={`ctr-order-items-shiplist-pricewrap-${rowFfid}`}
            >
                {item.oldPrice && !isChild && (
                    <span
                        className="text-12 text-[#5C5C5C] line-through lg:text-16"
                        data-ffid={`lbl-order-items-shiplist-oldprice-${rowFfid}`}
                    >
                        {oldPrice}
                    </span>
                )}
                <span
                    className="text-12 lg:text-16"
                    data-ffid={`lbl-order-items-shiplist-price-${rowFfid}`}
                >
                    {currentPrice}
                </span>
            </div>

            {/* Quantity */}
            <div
                className="min-w-30 max-w-50 text-center text-12 sm:min-w-38 lg:text-16"
                data-ffid={`lbl-order-items-shiplist-qty-${rowFfid}`}
            >
                {item?.qty}
            </div>

            {/* Total */}
            <div
                className="min-w-[100px] max-w-[160px] text-right text-12 sm:min-w-72 font-semibold lg:text-16"
                data-ffid={`lbl-order-items-shiplist-total-${rowFfid}`}
            >
                {total}
            </div>
        </div>
    );
};


export default OrderDetailsPriceRow;
